// src/services/resultTableService
import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQuery } from './getBaseQuery';
import {
    GetResultTableRequest,
    PostResultTableRequest,
    DeleteResultTableRequest,
    PatchResultTableRequest,
    GetResultTableResponse,
    PostResultTableResponse,
    DeleteResultTableResponse,
    PatchResultTableResponse
} from './types/TResultTableServices';

const URL_Prefix = '/result_table';

export const resultTableService = createApi({
    reducerPath: 'resultTableService',
    baseQuery: getBaseQuery,
    tagTypes: ['ResultTable'],
    endpoints: (builder) => ({
        // GET /result_table/ - получение списка таблиц результатов
        getResultTable: builder.query<GetResultTableResponse, GetResultTableRequest>({
            query: (params) => ({
                url: `${URL_Prefix}/`,
                method: 'GET',
                params: params, // Используем params для query parameters
            }),
            providesTags: ['ResultTable'],
        }),

        // POST /result_table/ - создание новой таблицы результатов
        postResultTable: builder.mutation<PostResultTableResponse, PostResultTableRequest>({
            query: (tableData) => ({
                url: `${URL_Prefix}/`,
                method: 'POST',
                body: tableData,
            }),
            invalidatesTags: ['ResultTable'],
        }),

        // PATCH /result_table/{uuid}/ - частичное обновление таблицы результатов
        patchResultTable: builder.mutation<PatchResultTableResponse, PatchResultTableRequest>({
            query: (tableData) => ({
                url: `${URL_Prefix}/${tableData.uuid}/`,
                method: 'PATCH',
                body: tableData,
            }),
            invalidatesTags: ['ResultTable'],
        }),

        // DELETE /result_table/{uuid}/ - удаление таблицы результатов
        deleteResultTable: builder.mutation<DeleteResultTableResponse, DeleteResultTableRequest>({
            query: (body) => ({
                url: `${URL_Prefix}/${body.uuid}/`,
                method: 'DELETE',
            }),
            invalidatesTags: ['ResultTable'],
        }),

        // GET /result_table/{uuid}/ - получение конкретной таблицы результатов по UUID
        getResultTableByUuid: builder.query<GetResultTableResponse, { uuid: string }>({
            query: ({ uuid }) => ({
                url: `${URL_Prefix}/${uuid}/`,
                method: 'GET',
            }),
            providesTags: ['ResultTable'],
        }),

        // GET /result_table/by_well/{well_uuid}/ - получение таблиц результатов по скважине
        getResultTableByWell: builder.query<GetResultTableResponse, { well_uuid: string }>({
            query: ({ well_uuid }) => ({
                url: `${URL_Prefix}/${well_uuid}/`,
                method: 'GET',
            }),
            providesTags: ['ResultTable'],
        }),
    }),
});

// Экспортируем все хуки
export const {
    useGetResultTableQuery,
    usePostResultTableMutation,
    usePatchResultTableMutation,
    useDeleteResultTableMutation,
    useGetResultTableByUuidQuery,
    useLazyGetResultTableByUuidQuery,
    useGetResultTableByWellQuery,
    useLazyGetResultTableByWellQuery,
    useLazyGetResultTableQuery,
} = resultTableService;